<template>
  <app-base-main parentTable class="recharge-record">
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-select
          v-model="filter.buyType"
          :options="buyTypeOptions"
          width="200px"
          placeholder="购买类型"
        ></gj-select>
        <gj-search-input v-model="filter.dealNo" width="200px" placeholder="请输入流水号"></gj-search-input>
        <gj-select
          v-model="filter.payStatus"
          :options="recordPayStatusOptions"
          placeholder="状态"
          width="200px"
        ></gj-select>
        <gj-date-picker v-model="filter.accomplishDate" type="daterange"></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <div class="number-bg">
        <div class="number-content white-bg">
          <div class="left">
            <div :class="[remainingOrder.remainingQuantity === 0 ? 'line-red' : remainingOrder.remainingQuantity <= 1000 ? 'line-orange' : 'line-blue']"></div>
            <div class="number-detail">
              <span class="title">订单剩余量</span>
              <span :class="[remainingOrder.remainingQuantity === 0 ? 'count-red' : remainingOrder.remainingQuantity <= 1000 ? 'count-orange' : 'count-black']">{{remainingOrder.remainingQuantity}}</span>
              <span v-if="remainingOrder.isUsed === false" class="tips">您还未使用，赶紧去<span style="color:#1F6EEF" @click="openAuth">店铺授权</span>吧～</span>
               <span v-else-if="remainingOrder.remainingQuantity === 0" class="tips" ><span style="color:#F53F3F">剩余量不足</span>，去<span style="color:#1F6EEF" @click="openRecharge">购买套餐</span></span>
              <span v-else-if="remainingOrder.remainingQuantity <= 1000" class="tips">剩余量即将不足，去<span style="color:#1F6EEF" @click="openRecharge">购买套餐</span></span>
              <span v-else-if="remainingOrder.remainingQuantity > 1000" class="tips">预计还能使用{{remainingOrder.remainingUsage}}天</span>
            </div>
          </div>
          <div class="date">有效期至{{remainingOrder.expirationDate ? remainingOrder.expirationDate : '-'}}</div>
        </div>

        <div :class="['number-content', remainingOrder.remainingQuantity === 0 ? 'grep-bg' : 'white-bg']">
          <div class="left">
            <div :class="[remainingOrder.remainingQuantity === 0 ? 'line-grep' : remainingEmail.remainingQuantity <= 1000 ? 'line-orange' : 'line-blue']"></div>
            <div class="number-detail">
              <span class="title">关怀/站外剩余量</span>
              <span :class="[remainingEmail.remainingQuantity <= 1000 ? 'count-orange' : 'count-black']">{{remainingEmail.remainingQuantity}}</span>
              <span v-if="remainingEmail.isUsed === false" class="tips">您还未使用，赶紧去创建一条<span :style="{'color': '#1F6EEF', 'pointer-events': (remainingOrder.remainingQuantity === 0 ? 'none' : 'auto')}"  @click="openSendRule">关怀邮件</span>规则吧～</span>
              <span v-else-if="remainingEmail.remainingQuantity === 0" class="tips" >剩余量不足，去<span :style="{'color': '#1F6EEF', 'pointer-events': (remainingOrder.remainingQuantity === 0 ? 'none' : 'auto')}"  @click="openRecharge">购买加油包</span></span>
              <span v-else-if="remainingEmail.remainingQuantity <= 1000" class="tips">剩余量即将不足，去<span :style="{'color': '#1F6EEF', 'pointer-events': (remainingOrder.remainingQuantity === 0 ? 'none' : 'auto')}"  @click="openRecharge">购买加油包</span></span>
              <span v-else-if="remainingEmail.remainingQuantity > 1000" class="tips">预计还能使用{{remainingEmail.remainingUsage}}天</span>
            </div>
          </div>
          <div v-if="remainingOrder.remainingQuantity === 0" class="date"><span style="color:#666666">无法使用</span></div>
          <div v-else class="date">有效期至{{remainingEmail.expirationDate ? remainingEmail.expirationDate : '-'}}</div>
        </div>

        <div :class="['number-content', remainingOrder.remainingQuantity === 0 ? 'grep-bg' : 'white-bg']">
          <div class="left">
            <div :class="[remainingOrder.remainingQuantity === 0 ? 'line-grep' : remainingVirtual.remainingQuantity <= 1000 ? 'line-orange' : 'line-blue']"></div>
            <div class="number-detail">
              <span class="title">积点剩余量</span>
              <span :class="[remainingVirtual.remainingQuantity <= 1000 ? 'count-orange' : 'count-black']">{{remainingVirtual.remainingQuantity}}</span>
              <span v-if="remainingVirtual.remainingQuantity === 0" class="tips" >剩余量不足，去<span :style="{'color': '#1F6EEF', 'pointer-events': (remainingOrder.remainingQuantity === 0 ? 'none' : 'auto')}"  @click="openRecharge">购买加油包</span></span>
              <span v-else-if="remainingVirtual.remainingQuantity <= 1000" class="tips">剩余量即将不足，去<span :style="{'color': '#1F6EEF', 'pointer-events': (remainingOrder.remainingQuantity === 0 ? 'none' : 'auto')}"  @click="openRecharge">购买加油包</span></span>
              <!-- <span v-else-if="remainingVirtual.remainingQuantity > 1000" class="tips">预计还能添加{{remainingVirtual.remainingUsage}}关键词</span> -->
            </div>
          </div>
          <div v-if="remainingOrder.remainingQuantity === 0" class="date"><span style="color:#666666">无法使用</span></div>
          <div v-else class="date">有效期至{{remainingVirtual.expirationDate ? remainingVirtual.expirationDate : '-'}}</div>
        </div>
      </div>

    </template>
    <template #table>
      <gj-table
        name="rechargeRecord"
        adaptParent
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
        :pagination="pagination"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :default-sort="{ prop: 'accomplishDate', order: 'descending' }"
      >
        <template v-slot:payType="{ row }">
          <span>{{ row.payType ? row.payType.desc : '-' }}</span>
        </template>
        <template v-slot:payAmount="{ row }">
          <span>￥{{ (row.payAmount || 0) | amount }}</span>
        </template>
        <template v-slot:payStatus="{ row }">
          <gj-tag v-if="row.payStatus.code === 'SUCCESS'" type="text" :color="tagColors.greenText">{{row.payStatus.desc | defaultShow}}</gj-tag>
          <gj-tag v-if="row.payStatus.code === 'FAIL'" type="text" :color="tagColors.red">{{row.payStatus.desc | defaultShow}}</gj-tag>
          <gj-tag v-if="row.payStatus.code === 'AUDIT'" type="text" :color="tagColors.blue">{{row.payStatus.desc | defaultShow}}</gj-tag>
        </template>
        <template v-slot:orderNumber="{ row }">
          <span>{{ _.add(row.orderNumber, (row.packageOrderNum || 0), (row.zsOrderNum || 0)) }}</span>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { payRecordPage, getPayRecordQuantity } from "../../../../api/setting";
import { queryMixin, selectionMixin } from "../../../../minxins";
import { convertToDate } from "../../../../utils/date.util";
import { recordPayStatus } from "../../../../utils/options";
import { tagColors } from "@/components/tag/tag-colors";
import { isMeaningful } from '@/utils/common';

export default {
  name: "app-recharge-record",
  mixins: [queryMixin, selectionMixin],
  data() {
    return {
      tagColors,
      tableData: [],
      columns: [
        { id: 'outTradeNo', header: '订单号', field: 'outTradeNo', minWidth: '180px', fixed: 'left' },
        { id: 'content', header: '购买内容', field: 'content', minWidth: '220px', overflowLine: 2, fixed: 'left' },
        { id: 'orderNumber', header: '购买订单量', field: 'slot:orderNumber', minWidth: '100px', fixed: 'left', },
        { id: 'emailNumber', header: '邮件数量', field: 'emailNumber', minWidth: '100px', fixed: 'left', },
        { id: 'virtualNumber', header: '积点数量', field: 'virtualNumber', minWidth: '100px', fixed: 'left', },
        { id: 'payType', header: '支付方式', field: 'slot:payType', minWidth: '100px' },
        { id: 'dealNo', header: '交易流水号', field: 'dealNo', minWidth: '240px' },
        { id: 'amount', header: '支付金额', field: 'slot:payAmount', minWidth: '120px', align: 'right' },
        { id: 'payStatus', header: '状态', field: 'slot:payStatus', minWidth: '80px' },
        { id: 'userName', header: '操作人', field: 'userName', minWidth: '120px' },
        { id: 'accomplishDate', header: '完成充值时间', field: 'accomplishDate', minWidth: '185px', sortable: true },
      ],
      filter: {
        dealNo: null,
        accomplishDate: [],
        payStatus: null,
        buyType: null
      },
      recordPayStatusOptions: recordPayStatus,
      buyTypeOptions: [
        { id: "1", text: '固定套餐包' },
        { id: "2", text: '邮件加油包' },
        { id: "3", text: '关键词监控工具加油包' },
        { id: "4", text: '跟卖监控工具加油包' },
        { id: "5", text: '积点' }
      ],
      remainingOrder: {},   //订单剩余量 
      remainingEmail: {},   //邮件剩余量 
      remainingVirtual: {}, //积点剩余量
      orderNumber: 1024,
      emailNumber: 123,
      gjNumber: 456,
      isUse: true,
    }
  },
  created() {
     this.getAllNumber();
  },
  activated() {
     this.getAllNumber();
  },
  methods: {
    $gjQueryInitParams() {
      return {
        filter: {
          dealNo: null,
          accomplishDate: [],
          payStatus: null
        }
      };
    },
    $gjQuery() {
      // 分页查询
      this.loading = true;
      const params = {
        model: {
          dealNo: this.filter.dealNo,
          payStatus: this.filter.payStatus,
          buyType: this.filter.buyType,
          startDate: this.filter.accomplishDate === null ? null : convertToDate(this.filter.accomplishDate[0]),
          endDate: this.filter.accomplishDate === null ? null : convertToDate(this.filter.accomplishDate[1])
        },
        ...this.queryPagination,
        ...this.querySort
      };
      payRecordPage(params).then(response => {
        this.tableData = response.data.records;
        this.pagination = this.getPagination(response.data);
      }).complete(() => {
        this.loading = false;
      })
    },
    //剩余量数据
    getAllNumber() {
      getPayRecordQuantity().then(res => {
        if(isMeaningful(res)) {
          this.remainingOrder = res.remainingOrder ? res.remainingOrder : {};
          this.remainingEmail = res.remainingEmail ? res.remainingEmail : {};
          this.remainingVirtual = res.remainingVirtual ? res.remainingVirtual : {};
        }
      })

    },
    //店铺授权
    openAuth() {
      if (this.$route.path !== "/system/market") {
        this.$router.push({ path: "/system/market" });
      }
    },
    //关怀邮件
    openSendRule() {
      if (this.$route.path !== "/crm/send-rule") {
        this.$router.push({ path: "/crm/send-rule" });
      }
    },
    //购买套餐
    openRecharge() {
      if (this.$route.path !== "/setting/erp-package") {
        this.$router.push({ path: "/setting/erp-package" });
      }
    },
  }
}
</script>

<style scoped lang="scss">
.number-bg {
  display: flex;
  flex-direction: row;
}

.white-bg {
  background: #FFFFFF;
  border: 1px solid #E5E6EB;
}

.grep-bg {
  background: #F2F3F5;
  border: 1px solid #F6F7F8;
}
.number-content {
  display: flex;
  margin-right: 24px;
  min-width: 380px;
  max-width: 410px;
  border-radius: 4px;
  padding: 14px 16px;
  
  .left {
    flex: 1;
    display: flex;

    .line-blue {
      float: left;
      margin-top: 2px;
      margin-bottom: 2px;
      width: 4px;
      height: 66px;
      background: #0045F0;
      border-radius: 25px;
    }

     .line-red {
      float: left;
      margin-top: 2px;
      margin-bottom: 2px;
      width: 4px;
      height: 66px;
      background: #F53F3F;
      border-radius: 25px;
    }

    .line-grep {
      float: left;
      margin-top: 2px;
      margin-bottom: 2px;
      width: 4px;
      height: 66px;
      background: #D8DADD;
      border-radius: 25px;
    }
    .line-orange {
      float: left;
      margin-top: 2px;
      margin-bottom: 2px;
      width: 4px;
      height: 66px;
      background: #ED6A0C;
      border-radius: 25px;
    }

    .number-detail {
      float: left;
      display: flex;
      flex-direction: column;
      margin-left: 24px;

      .title {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #666666;
      }

      .count-black {
        margin-top: 10px;
        font-weight: 700;
        font-size: 20px;
        line-height: 18px;
        color: #000000;
      }

      .count-red {
        margin-top: 10px;
        font-weight: 700;
        font-size: 20px;
        line-height: 18px;
        color: #F53F3F;
      }

      .count-orange {
        margin-top: 10px;
        font-weight: 700;
        font-size: 20px;
        line-height: 18px;
        color: #ED6A0C;
      }

      

      .tips {
        margin-top: 8px;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #999999;
      }
    }
  }
  .date {
    width: 130px;
    text-align: right;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #999999;
  }

 
}
</style>
